import { Platform } from "react-native";
export const CircleButton = Platform.OS === "web" ? require("./circle-button-web").CircleButtonWeb : require("./circle-button-native").CircleButtonNative;
